import React, { memo, useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Button,
  TextField,
  Typography,
  Grid,
  Chip,
  Modal,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Autocomplete } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";


function ObgyngenericAccordion({
  title,
  sections = [], // [{ key, label, selected, unselected, searchValue, showNotes, notes }]
  diagnosis = [],
  onAddKeyword,
  onToggleUnToSel,
  onToggleSelToUn,
  onClearAll,
  onSelectAll,
  onSearchChange,
  onNotesChange,
  onDeleteUnselected,
}) {
  const [modalOpen, setModalOpen] = useState(false);
  const [activeKey, setActiveKey] = useState(null);
  const [label, setlabel] = useState(null);

  const handleOpenModal = (key, label) => {
    setActiveKey(key);
    setlabel(label);
    setModalOpen(true);
  };
  const handleCloseModal = () => {
    setActiveKey(null);
    setlabel(null);
    setModalOpen(false);
  };

  return (
    <>
      <Accordion
        variant="outlined"
        disableGutters
        square
        TransitionProps={{ timeout: 0 }}
        sx={{
          mb: 1.5,
          borderRadius: 1,
          borderColor: "divider",
          bgcolor: "background.paper",
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
          sx={{
            bgcolor: "#2E7D32",
            color: "#fff",
            px: 2,
            py: 1.25,
            minHeight: 44,
            "& .MuiAccordionSummary-content": { m: 0, alignItems: "center" },
          }}
        >
          <Typography sx={{ fontWeight: 700, fontSize: 14 }}>{title}</Typography>
        </AccordionSummary>

        <AccordionDetails sx={{ p: 2 }}>
          {sections.map((sec) => {
            return (
              <Box key={sec.key} sx={{ mb: 2 }}>
               

                {/* Selected */}
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <Box
                      sx={{
                        background:
                          "linear-gradient(135deg,#f6fff7 0%,#ecfef0 100%)",
                        border: "1px solid #a5d6a7",
                        borderRadius: 2,
                        p: 2,
                        mb: 2,
                        boxShadow: "0 2px 6px rgba(76,175,80,0.08)",
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: 700,
                          mb: 1.2,
                          fontSize: 14,
                          color: "#1b5e20",
                        }}
                      >
                        ✅ Selected Keywords{" "}
                        <Box
                          component="span"
                          sx={{
                            fontSize: 12,
                            fontWeight: 500,
                            color: "#388e3c",
                            background: "#e8f5e9",
                            borderRadius: 1,
                            px: 0.7,
                            py: 0.2,
                          }}
                        >
                          {(sec.selected || []).length}
                        </Box>
                      </Typography>

                      <Box
                        sx={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: 0.7,
                          maxHeight: 180,
                          overflowY: "auto",
                        }}
                      >
                        {(sec.selected || []).length > 0 ? (
                          sec.selected.map((label) => (
                            <Chip
                              key={label}
                              label={label}
                              size="small"
                              sx={{
                                borderRadius: "8px",
                                fontSize: 12.5,
                                fontWeight: 500,
                                color: "#fff",
                                backgroundColor: "#4caf50",
                                border: "1px solid #388e3c",
                              }}
                              // onDelete={() =>
                              //   onToggleSelToUn?.(sec.key, label)
                              // }
                            />
                          ))
                        ) : (
                          <Typography sx={{ color: "#999", fontSize: 13 }}>
                            No selected keywords
                          </Typography>
                        )}
                      </Box>
                    </Box>
                  </Grid>

                  {/* Unselected */}
                  <Grid item xs={12}>
                    <Box
                      sx={{
                        background:
                          "linear-gradient(135deg,#f9fffa 0%,#f1fff5 100%)",
                        border: "1px solid #c8e6c9",
                        borderRadius: 2,
                        p: 2,
                        mb: 2,
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: 700,
                          mb: 1.2,
                          fontSize: 14,
                          color: "#1b5e20",
                        }}
                      >
                        🌿 Un‑Selected Keywords{" "}
                        <Box
                          component="span"
                          sx={{
                            fontSize: 12,
                            fontWeight: 500,
                            color: "#4caf50",
                            background: "#e8f5e9",
                            borderRadius: 1,
                            px: 0.8,
                            py: 0.2,
                          }}
                        >
                          {(sec.unselected || []).length}
                        </Box>
                      </Typography>

                      <Box
                        sx={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: 0.7,
                          maxHeight: 180,
                          overflowY: "auto",
                        }}
                      >
                        {(sec.unselected || []).length > 0 ? (
                          sec.unselected.map((label) => (
                            <Chip
                              key={label}
                              label={label}
                              variant="outlined"
                              color="success"
                              size="small"
                              sx={{
                                borderRadius: "8px",
                                fontSize: 12.5,
                                fontWeight: 500,
                                borderColor: "#81c784",
                                color: "#2e7d32",
                              }}
                              // onClick={() =>
                              //   onToggleUnToSel?.(sec.key, label)
                              // }
                              // onDelete={() => {
                              //   onDeleteUnselected
                              //     ? onDeleteUnselected(sec.key, label)
                              //     : onToggleUnToSel?.(sec.key, label);
                              // }}
                            />
                          ))
                        ) : (
                          <Typography sx={{ color: "#999", fontSize: 13 }}>
                            No unselected keywords
                          </Typography>
                        )}
                      </Box>
                    </Box>
                  </Grid>

                  

                  {/* Notes */}
                  {sec.showNotes && (
                    <Grid item xs={12}>
                      <TextField
                        multiline
                        minRows={3}
                        fullWidth
                        placeholder={`Notes for ${sec.label?.toLowerCase() || "section"}`}
                        value={sec.notes || ""}
                        onChange={(e) => onNotesChange?.(sec.key, e.target.value)}
                      />
                    </Grid>
                  )}
                </Grid>
              </Box>
            );
          })}
        </AccordionDetails>
      </Accordion>

    </>
  );
}

export default memo(ObgyngenericAccordion);